import { Directive, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ColumnDefinition, CustomCellComponent } from '@vendasta/va-filter2-table';
import { UserList } from '../user-list';

@Directive()
export class UserListsColumnComponent implements CustomCellComponent<UserList> {
  @Input() columnDefinition: ColumnDefinition;
  @Input() translateService: TranslateService;
  @Input() element: UserList;
}
